/**
 * Profile Hooks
 * React Query hooks for profile-related operations
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchUserInfo, fetchBetWinCount, fetchWagerCheck } from '@/services/api/profileService';
import { getUID } from '@/utils';

/**
 * Hook to fetch user info
 */
export const useUserInfo = (enabled = true) => {
  const uid = getUID();
  
  return useQuery({
    queryKey: ['userInfo', uid],
    queryFn: fetchUserInfo,
    enabled: enabled && !!uid,
    staleTime: 60000, // 1 minute
    retry: 2,
    retryDelay: 1000,
  });
};

/**
 * Hook to fetch bet and win counts
 */
export const useBetWinCount = (enabled = true) => {
  const uid = getUID();
  
  return useQuery({
    queryKey: ['betWinCount', uid],
    queryFn: fetchBetWinCount,
    enabled: enabled && !!uid,
    staleTime: 30000, // 30 seconds
    retry: 2,
    retryDelay: 1000,
  });
};

/**
 * Hook to fetch wager check data
 */
export const useWagerCheck = (enabled = true) => {
  const uid = getUID();
  
  return useQuery({
    queryKey: ['wagerCheck', uid],
    queryFn: fetchWagerCheck,
    enabled: enabled && !!uid,
    staleTime: 30000, // 30 seconds
    retry: 2,
    retryDelay: 1000,
  });
};
